var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "49",
      "height": "49"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M24.42.16c13.487 0 24.42 10.932 24.42 24.42C48.841 38.067 37.907 49 24.42 49S0 38.066 0 24.58 10.933.16 24.42.16"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M36.517 11h-24.03c-.822 0-1.487.665-1.487 1.488v24.026c0 .82.665 1.486 1.486 1.486h12.94V27.544h-3.54v-4.066h3.524v-3.014c0-3.486 2.125-5.386 5.229-5.386a28 28 0 0 1 3.142.163v3.643h-2.157c-1.695 0-2.02.806-2.02 1.986v2.603h4.038l-.53 4.066h-3.486v10.456h6.886c.82 0 1.488-.666 1.488-1.488v-24.02A1.49 1.49 0 0 0 36.517 11"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }